import { BaseResponse } from '../../../../../../../types/api/api.types';
import { CONSULTATIONS_ENDPOINTS } from '../../../../../../../utils/api/endpoints/consultationsEndpoints';
import { RemoveConsultationQuery } from './RemoveConsultationModal.types';

const PREFIX = '[removeConsultationQuery]';

export const REMOVE_CONSULTATION_QUERY_KEY = 'REMOVE_CONSULTATION';

export const removeConsultationQuery = async ({ consultationId }: RemoveConsultationQuery) => {
  console.log(PREFIX, `Requesting remove consultation...`);

  const response = await CONSULTATIONS_ENDPOINTS.remove(consultationId);

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received remove consultation.`);
  return json as BaseResponse;
};
